export const API_BASE_URL =
  process.env.REACT_APP_SOQUO_FEED_ORDER_URL || "http://localhost:10000";
